<template>
  <div>
    <div>version: {{ version }}</div>
    <div>commit: {{ commit }}</div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      version: process.env.VUE_APP_VERSION || 'dev',
      commit: process.env.VUE_APP_COMMIT || 'dev',
    };
  },
});
</script>
